import React from 'react';
import { Fade } from 'react-reveal';

function Travel() {

  const tours = [
    {
      id: 1,
      image: "/Assets/impallas.webp",
      country: "Kenya",
      subtitle: "Safari Adventure Awaits",
      description: "Kenya, East Africa's heart, invites with iconic savannahs teeming with wildlife. Experience Maasai Mara safaris, witness the Great Migration.",
      price: "3500"
    },
    {
      id: 2,
      image: "/Assets/giza.webp",
      country: "Egypt",
      subtitle: "Journey Through Time",
      description: "Uncover ancient wonders in Egypt. Visit the Pyramids of Giza, sail the Nile, explore Luxor's temples, and discover the Valley of the Kings.",
      price: "2800"
    },
    {
      id: 3,
      image: "/Assets/cape.webp",
      country: "Cape Town",
      subtitle: "Where Nature Meets Culture",
      description: "Cape Town, surrounded by nature, offers adventures on Table Mountain, poignant history, relax on pristine beaches.",
      price: "2200"
    },
    {
      id: 4,
      image: "/Assets/turkey.webp",
      country: "Turkey",
      subtitle: "Bridging Continents",
      description: "Istanbul blends centuries of history with modern life. Explore the Hagia Sophia, the Blue Mosque, and the vibrant Grand Bazaar. Cruise the Bosphorus and savor Turkish cuisine.",
      price: "2500"
    },
    {
      id: 5,
      image: "/Assets/peru.webp",
      country: "Peru",
      subtitle: "Beach Paradise Unveiled",
      description: "Mancora, Peru's hidden gem, offers sunshine, serene beaches, and fresh seafood. Surf Pacific waves, relax in beachfront resorts, and soak in natural hot springs.",
      price: "1800"
    },
    {
      id: 6,
      image: "/Assets/jordan.webp",
      country: "Jordan",
      subtitle: "Lost City Revisited",
      description: "Petra, the rose-red city carved in the Jordanian desert, unveils ancient artistry and ancient history. Explore the Siq, the Treasury, the Monastery, and High Place of Sacrifice.",
      price: "3000"
    },
    {
      id: 7,
      image: "/Assets/Cabo.webp",
      country: "Mexico",
      subtitle: "Coastal Escape",
      description: "Bask on golden beaches, snorkel in crystal-clear waters, and enjoy world-class fishing. Explore the vibrant marina, dine seaside, and dance the night away.",
      price: "2300"
    },
    {
      id: 8,
      image: "/Assets/bali.webp",
      subtitle: "Island Serenity",
      country: "Indonesia",
      description: "Experience Balinese ceremonies, relax on pristine beaches, and explore terraced rice paddies. savor Balinese cuisine, and rejuvenate in holistic spas.",
      price: "2600"
    },
    {
      id: 9,
      image: "/Assets/greece.webp",
      subtitle: "Surreal Sunsets Await",
      country: "Greece",
      description: "White-washed charm, surreal sunsets, and volcanic beaches await. Explore villages, savor Mediterranean cuisine, and find romance and relaxation in every moment.",
      price: "2800"
    },
  ]

  const handleSubmit = (id) => {
    alert('clicked me' + id);
  }

  return (
    <div className='travel-cont'>
      <div className="banner">
      <Fade left>
        <h1>Travel</h1>
        <h2>TOP DESTINATIONS</h2> </Fade>
      </div>

      <div className="travel-main">
        {tours.map(tour => {
          return (
            <Fade left>
              <div className="cards" key={tour.id}>
                <img src={tour.image} alt={tour.subtitle} />
                <h2>{tour.country}</h2>
                <h4>{tour.subtitle}</h4>
                <p>{tour.description}</p>
                <h5>$ {tour.price}</h5>
                <button type='button' onClick={() => handleSubmit(tour.id)}>More Details</button>
            </div>
            </Fade>
          )
        })}
      </div>

    </div>
  )
}

export default Travel;